// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.MachineLearningStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------


import { action, observable , toJS  } from 'mobx';

/**
 * Izenda Performace View Model
 */
export default class MLSettings {

    @observable predictionServerStatus = {};
    @observable mlDBConnectionStatus = {};
    @observable mlServerIp = '';
    @observable dbConnectionStringInput = '';
    @observable dbConectionActive =  false;
    @observable predictionServerSuccess = false;
    @observable dbServerSuccess = false;
    @observable dbServerHasLoaded = false;
    @observable dbConnectionShow = true;


    clone() {
      const data = toJS(this);
      const cloned = new MLSettings();
      cloned.readInitialData(data, data.type);
      return cloned;
    }

    @action
    readInitialData(data, type) {
      data = data || {};
      this.predictionServerStatus = data.predictionServerStatus;
      this.mlDBConnectionStatus = data.mlDBConnectionStatus;
      this.mlServerIp = data.mlServerIp;
      this.dbConnectionStringInput = data.dbConnectionStringInput;
      this.dbConectionActive = data.dbConectionActive || true;
      return Promise.resolve();
    }




     /**
   * Change function name
   * @param {string} valuepre
   */

     changePredictionInput(valuepre){
        this.mlServerIp = valuepre;
        this.predictionServerSuccess = false;
      }

      /**
   * Change function name
   * @param {string} value
   */

      changeDBName(value){
        this.dbConnectionStringInput = value;
        this.dbServerSuccess = false;
      };

    /**
     * change db Connection Show
     */
    changeDBConnectionShow(value) {
      this.dbConnectionShow = value;
    }

}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.MLSettings.js